import stressTest from './stressTest.js'
import preapproval from './preapproval.js'
import defaultInsurance from './defaultInsurance.js'
import mortgageAmortization from './mortgageAmortization.js'
import mortgageTerm from './mortgageTerm.js'
import fthbi from './fthbi.js'
import mortgageRate from './mortgageRate.js'
import downPayment from './downPayment.js'
import mortgageBroker from './mortgageBroker.js'
import realEstateAgents from './realEstateAgents.js'
import landSurvey from './landSurvey.js'
import propertyTypes from './propertyTypes.js'
import lawyer from './lawyer.js'
import fraud from './mortgageFraud.js'
import landTransferRebate from './landTransferRebate.js'
import appraiser from './appraiser.js'

const lessons = [
  fraud,
  lawyer,
  propertyTypes,
  landSurvey,
  realEstateAgents,
  mortgageBroker,
  preapproval,
  stressTest,
  defaultInsurance,
  mortgageAmortization,
  mortgageRate,
  fthbi,
  mortgageTerm,
  downPayment,
  landTransferRebate,
  appraiser,
]

export default lessons



// WEBPACK FOOTER //
// src/content/lessons.js